export default __webpack_public_path__ + "static/media/info-circle-filled.594d0db1.svg";